'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkList, LinkListItem } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { Accordion } from '@libs/shared-ui/components/Accordion';
import { parseRichText } from '../../../../utils/parseRichText';
import { FaqStoreCard } from '../faq-store-card';
import type { FaqItem } from '../types';
type FaqAccordionGroupProps = Readonly<{
  items: FaqItem[];
}>;
function renderAccordionContent(content: FaqItem['content']) {
  switch (content.type) {
    case 'links':
      return <LinkList className="faq-list">
                    {content.links.map(link => <LinkListItem key={link.id} text={link.text} href={link.href} />)}
                </LinkList>;
    case 'rich-text':
      return <div className="faq-list">{parseRichText(content.document)}</div>;
    case 'stores':
      return <div className="faq-store-cards">
                    {content.stores.map(card => <FaqStoreCard key={card.id} {...card} />)}
                </div>;
  }
}
export function FaqAccordionGroup(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="faq-accordion-group"><Accordion className="faq-accordions" items={t1} /></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  return {
    id: item.id,
    title: item.title,
    className: cn({
      "faq-question": item.content.type === "rich-text"
    }),
    children: renderAccordionContent(item.content)
  };
}